import { IPurchaseOrderRow } from 'interfaces';
import { BaseService } from './BaseService';

class OrderLineService extends BaseService<IPurchaseOrderRow> {
  constructor() {
    super('purchordlines');
  }
}

export const orderLineService = new OrderLineService();
